import * as React from 'react';
import { Button } from '../../../../components-v2/Button';
import { useCompaniesPageUrlState } from '..';
import { DefaultCompaniesSort, DefaultCompanySearchProperty, useCompaniesSearch } from '../CompaniesContext';

export const CompaniesClearSearchButton: React.FC = () => {
	const { setSort } = useCompaniesSearch();
	const [{ companySearchValue, companyOrTags, companyAndTags, companyNotTags }, setCompanyFilterSearch] =
		useCompaniesPageUrlState();

	const hasTextSearch = companySearchValue !== '';
	const hasTagFilters = companyOrTags.length > 0 || companyAndTags.length > 0 || companyNotTags.length > 0;
	if (!hasTextSearch && !hasTagFilters) {
		return null;
	}

	const onClear = () => {
		setCompanyFilterSearch({
			companySearchProperty: DefaultCompanySearchProperty,
			companySearchValue: '',
			companyOrTags: [],
			companyAndTags: [],
			companyNotTags: [],
		});
		setSort(DefaultCompaniesSort);
	};

	return (
		<Button variant='secondary' onClick={onClear}>
			Clear search
		</Button>
	);
};
